module.exports = __webpack_public_path__ + "img/2.4c729307.png";